import { render, staticRenderFns } from "./SalonMng.vue?vue&type=template&id=8f5280a4"
import script from "./SalonMng.vue?vue&type=script&lang=js"
export * from "./SalonMng.vue?vue&type=script&lang=js"
import style0 from "./SalonMng.vue?vue&type=style&index=0&id=8f5280a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports